module.exports = __webpack_public_path__ + "img/ie_logo_fullwidth.735ce87f.jpg";